import React from 'react'

function EmployeeListLoading() {
  return (
        <>
    <table className="w-full">
        <thead className="bg-slate-50">
              <tr>
                <th className="px-6 py-4 font-semibold text-slate-600 text-left">
                  S.No
                </th>
                <th className="px-6 py-4 font-semibold text-slate-600 text-left">
                  Name
                </th>
                <th className="px-6 py-4 font-semibold text-slate-600 text-left">
                  Location
                </th>
                <th className="px-6 py-4 font-semibold text-slate-600 text-left">
                  Email
                </th>
                <th className="px-6 py-4 font-semibold text-slate-600 text-left">
                  Emplyee ID
                </th>
                <th className="px-6 py-4 font-semibold text-slate-600 text-center">
                  Actions
                </th>
              </tr>
            </thead>

             <tbody className="divide-y divide-slate-100">
                 {Array.from({length:8}).map((_,index)=>(
                <tr key={index} className="hover:bg-slate-200 p-3 h-12 border-b-2">
                <td className=''>   
                   <div className='flex justify-center items-center w-5 h-3 bg-slate-300 animate-pulse'> </div>
                </td>

                <td className=''>
                   <div className='w-64 h-3 bg-slate-300 animate-pulse'> </div>
                </td>

                <td className=''>
                   <div className='w-32 h-3 bg-slate-300 animate-pulse'> </div>
                </td>

                <td className=''>
                   <div className='w-64 h-3 bg-slate-300 animate-pulse'> </div>
                </td>

                <td className=''>
                   <div className='w-16 h-3 bg-slate-300 animate-pulse'> </div>
                </td>

                <td >
                <div className='w-full h-3 flex justify-center gap-4'> 
                  <div className='p-2 bg-slate-300 animate-pulse'></div>
                  <div className='p-2 bg-slate-300 animate-pulse'></div>
                  <div className='p-2 bg-slate-300 animate-pulse'></div>
                  <div className='p-2 bg-slate-300 animate-pulse'></div>
                </div>
                </td>

                </tr>
                ))}

             </tbody>
    </table>
    </>
  )
}

export default EmployeeListLoading
